module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/move-bid-dialog/move-bid-dialog.component.css
// module id = ./src/app/shared/components/move-bid-dialog/move-bid-dialog.component.css
// module chunks = main